import { Pipe, PipeTransform } from '@angular/core';
import { IconMapService } from '../services/ingress-ikon.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'ingressIconPipe'
})
export class IngressIconPipePipe implements PipeTransform {
  constructor(private iconService: IconMapService,private sanitizer: DomSanitizer) {}

   transform(value: string): SafeHtml {
    if (!value) return value;
    let output = value;
    const map = this.iconService.getMap();

    Object.keys(map).forEach(name => {
      const regex = new RegExp(`\\b${name}\\b`, 'g');
      console.log("Pipe line Error Debug In Pipe------------>>",map[name]);
      output = output.replace(
        regex,
        `${name} <span class="astro-icon">${map[name]}</span>`
      );
    });

    return this.sanitizer.bypassSecurityTrustHtml(output);
  }

}
